import { CSSProperties } from "react";
import { Flex } from "grid-styled";
import styled from "styled-components";
import { H3, Image, shadows, transition } from "@evergis/ui";

export const MapControlContainer = styled.div<{
  width?: CSSProperties["width"];
  minWidth?: CSSProperties["minWidth"];
  withPadding?: boolean;
  disabled?: boolean;
}>`
  height: 100%;
  width: ${({ width }) => width || "auto"};
  min-width: ${({ minWidth }) => minWidth};
  display: flex;
  padding-left: ${({ withPadding }) => (withPadding ? ".25rem" : "0")};
  padding-right: ${({ withPadding }) => (withPadding ? ".25rem" : "0")};
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  flex-direction: row;
  align-items: center;
  justify-content: center;
  box-shadow: ${shadows.raised};
  background: ${({ theme: { palette } }) => palette.panelBackground};
  backdrop-filter: blur(10px);
  margin-right: 0.5rem;
  z-index: 4;
  pointer-events: ${({ disabled }) => disabled && "none"};
  opacity: ${({ disabled }) => disabled && "0.6"};
`;

export const TextContainer = styled.div<{ margin?: string; width?: string; buttonText?: boolean; alignEnd?: boolean }>`
  height: 2rem;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  user-select: none;
  cursor: default;
  align-items: ${({ alignEnd }) => (alignEnd ? "flex-end" : "center")};
  width: ${({ width }) => width || "auto"};
  color: ${({ theme: { palette } }) => palette.textSecondary};
  font: ${({ theme: { fonts }, buttonText }) => (buttonText ? fonts.button : fonts.description)};
`;

export const BookmarkPopupContainer = styled(MapControlContainer)`
  max-height: 24rem;
  box-sizing: border-box;
  align-items: flex-start;
  flex-direction: column;
  width: 24rem;
  padding: 1rem 1rem 1.5625rem 1.5625rem;
  margin-bottom: 0.625rem;
`;

export const Header = styled(Flex)`
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1rem;
`;

export const Title = styled(H3)`
  margin: 0;
`;

export const ContentText = styled.p`
  width: 100%;
  text-align: center;
  color: ${({ theme: { palette } }) => palette.textSecondary};
  margin: 0;
`;

export const BookmarkItemImage = styled(Image)`
  transition: opacity ${transition.show};
  opacity: 0.36;
`;

export const BookmarkItemTitle = styled(ContentText)`
  transition: color ${transition.hover};
  margin: 0 0.9375rem;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-height: calc(90px / 4 - 0.125rem);
  max-height: 90px;
`;

export const BookmarkTitleContainer = styled(Flex)`
  width: 100%;
  flex-wrap: nowrap;
  align-items: center;
`;

export const BookmarkZoomLevelContainer = styled(Flex)`
  margin-left: 2rem;
  align-items: flex-end;
`;

export const BookmarkZoomLevel = styled(ContentText)`
  font-size: 0.75rem;
  margin-left: 0.25rem;
`;

export const BookmarkItemContainer = styled(Flex)`
  flex-direction: column;
  cursor: pointer;
  flex-shrink: 0;
  align-items: center;
  width: 100%;
  padding-bottom: 0.9375rem;
  &:last-child {
    padding-bottom: 0;
  }
  &:hover {
    ${BookmarkItemImage} {
      opacity: 1;
    }
    ${BookmarkItemTitle} {
      color: ${({ theme: { palette } }) => palette.textPrimary};
    }
  }
`;

export const BookmarksItemScroll = styled(Flex)`
  width: 100%;
  overflow-y: auto;
  flex-direction: column;
`;
